<template>
  <PageWrapper
    v-if="apiData"
    :twitterImage="apiData.options.meta_info.twitter_card"
    :ogImage="apiData.options.meta_info.open_graph_image"
    :pageTitle="apiData.options.meta_info.page_title"
    :pageDescription="apiData.options.meta_info.page_description"
  >
    <WilderLogo :color="'black'" :bgcolor="'white'" :strokecolor="'black'"/>
    <ResponsiveFooter/>
  </PageWrapper>
</template>

<script>
import { mapState } from 'vuex'
import PageWrapper from '@/components/PageWrapper'
import ResponsiveFooter from '@/components/ResponsiveFooter'
import WilderLogo from '@/components/WilderLogo'

// VUE
export default {
  components: {
    PageWrapper,
    ResponsiveFooter,
    WilderLogo
  },
  computed: {
    ...mapState([
      'apiData'
    ])
  }
}
</script>
